import {
  CategoryCard
} from "./CategoryCard";

import type {
  Category
} from "../../types/catalog";

interface ShopByCategorySectionProps {
  categories: Category[];
  compact?: boolean;
  eyebrow?: string | null;
  title?: string | null;
  subtitle?: string | null;
}

export function ShopByCategorySection({
  categories,
  compact = false,
  eyebrow = "Shop by ritual",
  title = "Explore every RiNi collection",
  subtitle =
    "Discover thoughtfully prepared bodycare, haircare, lip care and gifting collections made in small batches."
}: ShopByCategorySectionProps) {
  const visibleCategories =
    categories
      .filter(
        (category) =>
          category.isActive &&
          category.slug !==
            "test-product"
      )
      .sort(
        (left, right) =>
          left.displayOrder -
          right.displayOrder
      );

  if (!visibleCategories.length) {
    return null;
  }

  return (
    <section className="bg-[#fffdf9] py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <div>
            {eyebrow && (
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#70845b]">
                {eyebrow}
              </p>
            )}

            {title && (
              <h2 className="mt-4 max-w-2xl font-serif text-4xl font-semibold leading-tight text-[#38251e] sm:text-5xl">
                {title}
              </h2>
            )}
          </div>

          {subtitle && (
            <p className="max-w-lg text-base leading-7 text-[#746d65]">
              {subtitle}
            </p>
          )}
        </div>

        <div
          className={[
            "mt-10 grid gap-5",
            compact
              ? "sm:grid-cols-2 lg:grid-cols-3"
              : "sm:grid-cols-2 xl:grid-cols-3"
          ].join(" ")}
        >
          {visibleCategories.map(
            (category) => (
              <CategoryCard
                key={category.id}
                category={category}
                compact={compact}
              />
            )
          )}
        </div>
      </div>
    </section>
  );
}
